import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../Screens/auth/Login";
import PageNotFound from "../Screens/auth/PageNotFound";
import Header from "../Screens/drawer/Header";
import Dashboard from "../Screens/drawer/Dashboard";
import HsCodeList from "../Screens/HsCode/HsCodeList";
import AddHsCode from "../Screens/HsCode/AddHsCode";
import CompaniesList from "../Screens/Company/CompaniesList";
import AddCompany from "../Screens/Company/AddCompany";
import AddItem from "../Screens/Items/AddItem";
import ItemList from "../Screens/Items/ItemList";
import AddBuyer from "../Screens/Buyers/AddBuyer";
import BuyersList from "../Screens/Buyers/BuyersList";
import AddInvoices from "../Screens/Invoices/AddInvoices";
import AddPosInvoice from "../Screens/Invoices/AddPosInvoice";
import InvoicesLIst from "../Screens/Invoices/InvoicesLIst";
import EditBuyer from "../Screens/Buyers/EditBuyer";
import EditInvoices from "../Screens/Invoices/EditInvoice";
import EditItem from "../Screens/Items/EditItem";
import InvoiceSummary from "../Screens/Invoices/InvoiceSummary";
import EditCompany from "../Screens/Company/EditCompany";
import FvrSnroTesting from "../Screens/FbrSnroTesting/Index";
import AddUser from "../Screens/Users/AddUser";
import ViewUser from "../Screens/Users/ViewUser";
import EditUser from "../Screens/Users/EditUser";
import UserScenerioTesting from "../Screens/Users/UserScenerioTesting";
import BulkInvoiceUploader from "../Screens/Invoices/BulkInvoiceUploader";
import ForgotPassword from "../Screens/auth/ForgotPassword";
import CreateNewPassword from "../Screens/auth/CreateNewPassword";
import ViewUserDetails from "../Screens/Users/ViewUserDetails";
import ViewBuyer from "../Screens/Buyers/ViewBuyer";
import BuyerLedger from "../Screens/Buyers/BuyerLedger";
import ViewCompany from "../Screens/Company/ViewCompany";
import PostDefaultProductionInvoice from "../Screens/Users/PostDefaultProductionInvoice";
import AdminDashboard from "../Screens/AdminDashboard/Index";
import LedgerReports from "../Screens/ledgerReports/Index";
import SubscriptionStatus from "../Screens/Subscriptions/Index";
import AddReceiving from "../Screens/Receiving/AddReceiving";
import EditReceiving from "../Screens/Receiving/EditReceiving";
import ReceivingList from "../Screens/Receiving/ReceivingList";
import ViewReceiving from "../Screens/Receiving/ViewReceiving";
import StockReport from "../Screens/Stock/StockReport";
import StockLedger from "../Screens/Stock/StockLedger";
import ActiveTaxpayers from "../Screens/Atl/Index";
import ProgramSettings from "../Screens/ProgramSettings/Index";

export const Routing = () => {
  return (
    <Routes>
      <Route path="/" exact element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} /> 
      <Route path="/create-new-password" element={<CreateNewPassword />} />
      <Route path="/404/page-not-found" element={<PageNotFound />} />
      {window.localStorage.getItem("isAuthenticated") === "true" && (
        <Route path="/main" element={<Header />}>
          <Route index element={<Dashboard />} />
          <Route path="/main/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/main/view-hscode" element={<HsCodeList />} />
          <Route path="/main/add-hscode" element={<AddHsCode />} />
          <Route path="/main/add-company" element={<AddCompany />} />
          <Route path="/main/edit-company" element={<EditCompany />} />
          <Route path="/main/view-company-list" element={<CompaniesList />} />
          <Route path="/main/view-company-details" element={<ViewCompany />} />
          <Route path="/main/add-item" element={<AddItem />} />
          <Route path="/main/edit-item" element={<EditItem />} />
          <Route path="/main/view-item-list" element={<ItemList />} />
          <Route path="/main/add-receiving" element={<AddReceiving />} />
          <Route path="/main/edit-receiving" element={<EditReceiving />} />
          <Route path="/main/view-receiving-list" element={<ReceivingList />} />
          <Route path="/main/view-receiving-details" element={<ViewReceiving />} />
          <Route path="/main/stock-ledger" element={<StockLedger />} />
          {/* The reports keep their URLs; the menu reaches them through the
              Reports tab (/main/reports, Screens/ledgerReports). */}
          <Route path="/main/stock-report" element={<StockReport />} />
          <Route path="/main/add-buyer" element={<AddBuyer />} />
          <Route path="/main/edit-buyer" element={<EditBuyer />} />
          <Route path="/main/view-buyer-list" element={<BuyersList />} />
          <Route path="/main/view-buyer-details" element={<ViewBuyer />} />
          <Route path="/main/buyer-ledger" element={<BuyerLedger />} />
          <Route path="/main/add-invoice" element={<AddInvoices />} />
          <Route path="/main/add-pos-invoice" element={<AddPosInvoice />} />
          <Route path="/main/edit-invoice" element={<EditInvoices />} />
          <Route path="/main/view-invoice-list" element={<InvoicesLIst />} />
          <Route path="/main/view-invoice-summary" element={<InvoiceSummary />} />
          <Route path="/main/bulk-invoice-uploader" element={<BulkInvoiceUploader />} />
          <Route path="/main/fbr-scenerio-testing" element={<FvrSnroTesting />} />
          <Route path="/main/add-user" element={<AddUser />} />
          <Route path="/main/edit-user" element={<EditUser />} />
          <Route path="/main/view-user-list" element={<ViewUser />} />
          <Route path="/main/view-user-details" element={<ViewUserDetails />} />
          <Route path="/main/user-fbrscenerio-testing" element={<UserScenerioTesting />} />
          <Route path="/main/post-production-invoice" element={<PostDefaultProductionInvoice />} />
          <Route path="/main/reports" element={<LedgerReports />} />
          <Route path="/main/subscriptions" element={<SubscriptionStatus />} />
          <Route path="/main/active-taxpayers" element={<ActiveTaxpayers />} />
          <Route path="/main/program-settings" element={<ProgramSettings />} />
        </Route>
      )}
      <Route path="*" element={<Navigate to="/404/page-not-found" replace />} />
    </Routes>
  );
};
